import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import SiteLayout from "@/components/site/SiteLayout";
import { ServiceCard } from "@/components/site/HomeSections";

const ServicesPage = () => {
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [params, setParams] = useSearchParams();
  const active = params.get("categoria") || "";

  useEffect(() => {
    api.get("/public/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/public/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  const filtered = active ? services.filter((s) => s.category === active) : services;
  const usedCats = categories.filter((c) => services.some((s) => s.category === c.name));

  const setCat = (name) => {
    if (name) setParams({ categoria: name });
    else setParams({});
  };

  return (
    <SiteLayout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <h1 className="text-2xl sm:text-3xl font-bold font-heading text-foreground mb-1">Serviços</h1>
        <p className="text-sm text-muted-foreground mb-4">Profissionais e serviços em Pocinhos-PB</p>

        {usedCats.length > 0 && (
          <div className="flex gap-2 overflow-x-auto hide-scrollbar pb-3 mb-4">
            <button
              onClick={() => setCat("")}
              data-testid="filter-all"
              className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold border transition-colors ${!active ? "bg-primary text-primary-foreground border-primary" : "bg-card text-foreground border-border"}`}
            >
              Todas
            </button>
            {usedCats.map((c) => (
              <button
                key={c.id}
                onClick={() => setCat(c.name)}
                data-testid={`filter-${c.name}`}
                className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold border transition-colors ${active === c.name ? "bg-primary text-primary-foreground border-primary" : "bg-card text-foreground border-border"}`}
              >
                {c.name}
              </button>
            ))}
          </div>
        )}

        {filtered.length === 0 ? (
          <p className="text-muted-foreground py-10 text-center">Nenhum serviço encontrado.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
            {filtered.map((s) => <ServiceCard key={s.id} s={s} />)}
          </div>
        )}
      </div>
    </SiteLayout>
  );
};

export default ServicesPage;
